import MessageLoader from "app/pages/sales-intelligence/modules/ai-agent/components/MessageLoader";
import MessagesList, {
    type MessagesListProps,
} from "app/pages/sales-intelligence/modules/ai-agent/components/MessagesList/MessagesList";
import type { ChatUiContext } from "app/pages/sales-intelligence/modules/ai-agent/components/MessagesList/types";
import { StyledMessageBubble } from "app/pages/sales-intelligence/modules/ai-agent/components/styles";
import { groupHumanRequestsWithAiResponses } from "app/pages/sales-intelligence/modules/ai-agent/utils/groupMessages";

import { LeadGeneratorMessage } from "../../LeadGeneratorMessage";

const UI_CONTEXT: ChatUiContext = {
    chatTheme: "embedded",
    renderMode: "grouped",
    loader: <MessageLoader variant="small" />,
    markdownComponent: LeadGeneratorMessage,
};

type Props = Pick<
    MessagesListProps,
    "messages" | "isLoading" | "lastAiMessageRef" | "lastUserMessageRef" | "mdComponentProps"
>;

export const ChatMessages = ({
    messages,
    isLoading,
    lastUserMessageRef,
    lastAiMessageRef,
    mdComponentProps,
}: Props) => {
    const showInitialLoader = isLoading && messages.length === 0;
    const showMessagesList = !showInitialLoader && messages.length > 0;

    if (showInitialLoader) {
        return (
            <StyledMessageBubble>
                <MessageLoader variant="large" />
            </StyledMessageBubble>
        );
    }

    if (!showMessagesList) {
        return null;
    }

    return (
        <MessagesList
            uiContext={UI_CONTEXT}
            messages={messages}
            groupBy={groupHumanRequestsWithAiResponses}
            isLoading={isLoading}
            mdComponentProps={mdComponentProps}
            lastUserMessageRef={lastUserMessageRef}
            lastAiMessageRef={lastAiMessageRef}
            withControls={false}
        />
    );
};
